import React from 'react';
import MainParticle from '../Components/MainParticle';
import styled from 'styled-components';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedinIcon from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import PinterestIcon from '@material-ui/icons/Pinterest';

function HomePage() {
  return (
    <HomePageStyled>
      <div className="particle-con">
        <MainParticle />
      </div>
      <div className="typography">
        <h1>
          Hi, I am <span>Pedro Gonçalves</span>
        </h1>

        <p>
          Currently finished my bachelor degree in Computer Science, but I am always eager to learn new things, and
          being productive.
          <br /> My biggest default is being lazy, but I always try to find the easy and quicky way to get to a
          solution.
        </p>
        <div className="icons">
          <a href="https://www.facebook.com/pedro.grou" target="_blank" rel="noreferrer" className="icon i-facebook">
            <FacebookIcon />
          </a>
          <a
            href="https://www.linkedin.com/in/pedro-gon%C3%A7alves-80461115a/"
            target="_blank"
            rel="noreferrer"
            className="icon i-linkedin"
          >
            <LinkedinIcon />
          </a>
          <a href="https://github.com/PedroGrou" target="_blank" rel="noreferrer" className="icon i-github">
            <GithubIcon />
          </a>
          <a
            href="https://www.pinterest.pt/pedrogroug/portfolio/"
            target="_blank"
            rel="noreferrer"
            className="icon i-pinterest"
          >
            <PinterestIcon />
          </a>
        </div>
      </div>
    </HomePageStyled>
  );
}

const HomePageStyled = styled.header`
  width: 100%;
  height: 100vh;
  position: relative;

  .typography {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 80%;

    .icons {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
      .icon {
        border: 2px solid var(--border-color);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        transition: all 0.4s ease-in-out;
        cursor: pointer;
        &:hover {
          border: 2px solid var(--primary-color);
          color: var(--primary-color);
        }
        &:not(:last-child) {
          margin-right: 1rem;
        }
        svg {
          margin: 0.5rem;
        }
      }
      .i-facebook {
        &:hover {
          border: 2px solid #3b5998;
          color: #3b5998;
        }
      }

      .i-linkedin {
        &:hover {
          border: 2px solid #0e76a8;
          color: #0e76a8;
        }
      }

      .i-youtube {
        &:hover {
          border: 2px solid red;
          color: red;
        }
      }
      .i-github {
        &:hover {
          border: 2px solid #5f4687;
          color: #5f4687;
        }
      }
      .i-pinterest {
        &:hover {
          border: 2px solid #e60023;
          color: #e60023;
        }
      }
    }
  }
`;

export default HomePage;
